/**
 * Roteador de layouts para campos editáveis inline (field | contact | cell).
 */
import { CellLayout } from './CellLayout';
import { ContactLayout } from './ContactLayout';
import { FieldLayout } from './FieldLayout';
import { SelectLayout } from './SelectLayout';
import type { InlineEditableProps } from './types';

export function InlineEditable(props: InlineEditableProps) {
    switch (props.layout) {
        case 'field':
            return <FieldLayout {...props} />;
        case 'contact':
            return <ContactLayout {...props} />;
        case 'cell':
            return <CellLayout {...props} />;
        case 'select':
            return <SelectLayout {...props} />;
        default:
            return null;
    }
}
